import { fontSize, primaryRegularFont, theme } from '@noths/polaris-client-ribbons-base';
import { inset } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var container = /*#__PURE__*/css(["display:flex;align-items:center;"]);
export var copy = /*#__PURE__*/css(["", ""], fontSize(text.BODY.MD));
export var heading = /*#__PURE__*/css(["", ";margin:0;"], primaryRegularFont);
export var button = /*#__PURE__*/css(["background:none;border:none;color:var(--brand-purple-base-high-contrast);text-decoration:underline;", ";padding:0;margin-left:auto;cursor:pointer;"], primaryRegularFont);
export var flag = /*#__PURE__*/css(["display:block;margin:", ";"], inset(spacing.xs, 0));